<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Chamados
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="busca"
        :server-items-length="total"
        :options.sync="options"
        :loading="carregando"
        loading-text="Carregando... Por favor aguarde"
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <v-row no-gutters align="center" justify="space-between">
            <div class="py-2 px-2">
              <v-row no-gutters>
                <div>
                  <VueCtkDateTimePicker
                    v-on:callback="changeDates"
                    v-model="data_entrada"
                    class="date-picker"
                    locale="pt-BR"
                    :no-header="true"
                    :no-value-to-custom-elem="true"
                    :overlay="true"
                    :range="true"
                    :formatted="'L'"
                    :format="'YYYY-MM-DD'"
                    color="#EC6521"
                    :dark="$vuetify.theme.dark"
                    button-color="#EC6521"
                    :custom-shortcuts="labels"
                    :no-button="true"
                    :noClearButton="true"
                    :auto-close="true"
                    :loading="loadingSearch"
                    :disabled="loadingSearch"
                    :submit="retornoData()"
                  >
                    <v-btn class="px-2 search_data" elevation="0" v-ripple="{ class: `success--text` }">
                      <b class="text text-primary">
                        Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                      </b>
                    </v-btn>
                  </VueCtkDateTimePicker>
                </div>
                <v-form @submit.prevent="applyFilter()">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="busca"
                    class="ml-3"
                    :loading="loadingSearch"
                    :disabled="loadingSearch"
                    outlined
                    label="Busca"
                    @click:clear="limparBusca()"
                  ></v-text-field>
                </v-form>
                <v-autocomplete
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="statusChamado"
                  label="Status"
                  append-icon="expand_more"
                  v-model="status"
                  hide-details=""
                  :loading="loadingSearch"
                  :disabled="loadingSearch"
                  outlined
                  @click:clear="limparBusca()"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
                <v-autocomplete
                  class="ml-3"
                  v-if="nivelUsuarioApelido === 'M'"
                  :menu-props="{ offsetY: true}"
                  :items="distribuidores"
                  label="Distribuidor"
                  append-icon="expand_more"
                  v-model="distribuidor"
                  hide-details=""
                  :loading="loading || loadingDistribuidores"
                  :disabled="loading || loadingDistribuidores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'"
                  :menu-props="{ offsetY: true}"
                  class="ml-3"
                  :items="integradores"
                  label="Integrador"
                  append-icon="expand_more"
                  v-model="integrador"
                  hide-details=""
                  :loading="loading || loadingIntegradores"
                  :disabled="loading || loadingIntegradores"
                  outlined
                  @click:clear="() => {
                    this.options.page = 1
                    this.applyFilter()
                  }"
                  clearable
                  clear-icon="close"
                  @change="applyFilter()"
                ></v-autocomplete>
                <!-- <v-switch
                  hide-details
                  class="ml-4 mt-1 mb-2"
                  color="success"
                  v-model="meus_chamados"
                  :loading="loadingSearch"
                  :disabled="loadingSearch"
                  :label="meus_chamados ? 'Meus chamados' : 'Todos os chamados'"
                  @change="applyFilter()"
                ></v-switch> -->
                <v-switch
                  hide-details
                  class="ml-4 mt-1 mb-2"
                  color="success"
                  v-model="atrasados"
                  :loading="loadingSearch"
                  :disabled="loadingSearch"
                  label="Atrasados"
                  @change="filtraAtrasados()"
                ></v-switch>
              </v-row>
            </div>
            <!-- <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="''">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="''">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">assignment</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para TXT</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div> -->
          </v-row>
        </template>
        <template v-slot:item.cliente="{ item }">
          <v-row no-gutters align="center">
            <span v-if="item.cliente">
              {{item.cliente.cli_nome}}
            </span>
            <v-chip class="ml-2" color="red" x-small v-if="item.atrasado && !item.cha_finalizado_em">
              Atrasado
            </v-chip>
          </v-row>
          <!-- <v-chip pill v-if="item.cliente">
            <v-avatar left>
              <v-img v-if="item.cliente.cli_imagem" :src="item.cliente.cli_imagem"></v-img>
              <v-img v-else :src="require('@/assets/img/logo-icon.png')"></v-img>
            </v-avatar>
          </v-chip> -->
        </template>
        <template v-slot:item.cha_criado_em="{ item }">
          <b>{{item.cha_criado_em ? item.cha_criado_em : '-'}}</b>
        </template>
        <template v-slot:item.cha_atualizado_em="{ item }">
          <b>{{item.cha_atualizado_em ? item.cha_atualizado_em : '-'}}</b>
        </template>
         <template v-slot:item.cha_finalizado_em="{ item }">
          <b>{{item.cha_finalizado_em ? item.cha_finalizado_em : '-'}}</b>
        </template>
        <template v-slot:item.prazo="{ item }">
          <b>{{item.prazo ? item.prazo : '-'}}</b>
        </template>
        <template v-slot:item.cha_status="{ item }">
          <v-chip v-if="item.cha_status == 0" class="mw_status" color="red">Aberto</v-chip>
          <v-chip v-if="item.cha_status == 1" class="mw_status" color="primary">Em Andamento</v-chip>
          <v-chip v-if="item.cha_status == 2" class="mw_status" color="green">Finalizado</v-chip>
        </template>
        <template v-slot:item.cha_descricao="{ item }">
          <div class="text" v-html="item.cha_descricao"></div>
        </template>
        <!-- <template v-slot:item.comentario="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="getComentarios(item)" color="primary" class="ml-2">
                3p
              </v-icon>
            </template>
            <span>Comentários</span>
          </v-tooltip>
         </template> -->
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="goToChamado(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="opendialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <div class="ui-create">
      <v-btn color="primary" elevation="3" @click="dialogNovo = true" :loading="loading" :disabled="loading">
        <v-icon color="white" x-large>add</v-icon>
      </v-btn>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="600px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{chamado.uuid_cha_id ? 'Editar' : 'Novo'}} chamado
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formChamado">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="chamado.uuid_cli_id"
                :items="clientes"
                clearable
                clear-icon="close"
                label="Cliente*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingClientes"
                :disabled="salvando || loadingClientes"
                outlined
              >
                <template #append-outer>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" @click="dialogCliente = true">
                        person_add
                      </v-icon>
                    </template>
                    <span>Novo cliente</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <vue-editor :class="$vuetify.theme.dark ? 'dark_theme' : ''" v-model="chamado.cha_descricao" :loading="salvando" :disabled="salvando" :editorToolbar="customToolbar"></vue-editor>
              <!-- <v-textarea
                outlined
                autofocus
                no-resize
                rows="3"
                v-model="chamado.cha_descricao"
                :rules="[rules.required]"
                label="Descrição*"
              ></v-textarea> -->
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="chamado.cha_status"
                :items="statusChamado"
                label="Status*"
                append-icon="expand_more"
                :loading="salvando"
                :disabled="salvando"
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditChamado()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogComentarios"
      persistent
      max-width="900px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Comentários
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogComentarios()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formComentarios" class="mb-3">
          <v-row justify="end">
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-textarea
                outlined
                no-resize
                rows="3"
                :rules="[rules.required]"
                v-model="comentario.cco_comentario"
                autofocus
                label="Comentário*"
                :disabled="salvando"
                :loading="salvando"
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pt-0">
              <v-btn
                color="primary"
                class="w-100"
                :loading="salvando"
                :disabled="salvando"
                @click="salvaComentario()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
       <v-data-table
          :headers="headersComentarios"
          :items="dadosComentarios"
          :search="searchComentario"
          multi-sort
          fixed-header
          height="300px"
          :loading="loadingComentarios"
          loading-text="Carregando... Por favor aguarde"
          class="elevation-1 base_table"
          :footer-props="{
            itemsPerPageOptions: [5,10,15,20,25,50,100],
            showFirstLastPage: true,
            firstIcon: 'skip_previous',
            lastIcon: 'skip_next',
            prevIcon: 'chevron_left',
            nextIcon: 'chevron_right'
          }"
          :header-props="{
            sortIcon: 'north',
          }"
        >
          <!-- <template v-slot:item.actions="{ item }">
            <v-row no-gutters align="center" justify="center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="editaComentario(item)" color="primary" class="mr-2">
                    edit
                  </v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteComentario(item)" color="primary" class="ml-2">
                    delete
                  </v-icon>
                </template>
                <span>Excluir</span>
              </v-tooltip>
            </v-row>
          </template> -->
        </v-data-table>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogComentarios()"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogCliente"
      persistent
      max-width="900px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Novo cliente
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogCliente()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formCliente">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-text-field
                autofocus
                v-model="cliente.cli_nome"
                label="Nome completo*"
                :rules="[rules.required, rules.min]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="cliente.cli_usuario"
                label="Login*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="cliente.cli_senha"
                outlined
                hint="Mínimo 6 caracteres"
                counter
                :rules="[rules.required, rules.min6]"
                label="Senha*"
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="cliente.cli_email"
                label="E-mail*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="cliente.cli_telefone"
                label="Telefone*"
                :rules="[rules.required]"
                :loading="salvando"
                :disabled="salvando"
                outlined
                v-mask="'(##) #####-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="cliente.cli_celular"
                label="Celular"
                :loading="salvando"
                :disabled="salvando"
                outlined
                v-mask="'(##) #####-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
            <v-text-field-cep
              v-model="cliente.cli_cep"
              label="CEP"
              :loading="loadingCep || salvando"
              :disabled="loadingCep || salvando"
              @change="searchCep(cliente.cli_cep)"
              v-bind:properties="{
                disabled: false,
                outlined: true,
                clearable: true,
                placeholder: '',
              }"
              v-bind:options="{
                outputMask: '########',
                empty: null,
                applyAfter: false,
              }"
            />
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-autocomplete
                v-model="cliente.cli_uf"
                autocomplete="off"
                :items="estados"
                :loading="salvando || loadingEstados || loadingCep"
                :disabled="salvando || loadingEstados || loadingCep"
                label="Estado"
                append-icon="expand_more"
                outlined
                @change="filterCidade(cliente.cli_uf)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-autocomplete
                autocomplete="off"
                v-model="cliente.cli_cidade"
                :items="cidadesFiltradas"
                :loading="salvando || loadingCidades || loadingCep"
                :disabled="salvando || loadingCidades || loadingCep"
                label="Cidade"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="cliente.cli_bairro"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Bairro"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pt-0">
              <v-text-field
                v-model="cliente.cli_rua"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Rua"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pt-0">
              <v-text-field
                v-model="cliente.cli_numero"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Número"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pt-0">
              <v-text-field
                v-model="cliente.cli_complemento"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Complemento"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" class="pt-0"  v-if="nivelUsuarioApelido === 'M' || nivelUsuarioApelido === 'D'">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="cliente.uuid_int_id"
                :items="integradoresCadastro"
                clearable
                clear-icon="close"
                label="Integrador*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingIntegradores"
                :disabled="salvando || loadingIntegradores"
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogCliente()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveCliente()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Chamado
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDialogDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Chamado <b class="text-primary">{{chamado ? chamado.cha_id : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelDialogDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeChamado()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import Api from '@API'
export default {
  components: {
    VueEditor,
    VueCtkDateTimePicker
  },
  data () {
    return {
      total: 0,
      carregando: false,
      options: {},
      sla: null,
      user: '',
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogComentarios: false,
      dialogCliente: false,
      loadingIntegradores: false,
      showPassword: false,
      showRepeatPassword: false,
      loadingCep: false,
      estados: [],
      cidades: [],
      clientes: [],
      loadingClientes: false,
      cidadesFiltradas: [],
      searchComentario: '',
      integradores: [],
      integradoresCadastro: [],
      integrador: null,
      distribuidor: null,
      distribuidores: [],
      distribuidorAnterior: null,
      // de: moment().startOf('month').format('YYYY-MM-DD'),
      de: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'),
      ate: moment(new Date()).format('YYYY-MM-DD'),
      data_entrada: {
        // start: moment().startOf('month').format('YYYY-MM-DD'),
        start: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      loadingSearch: false,
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ],
      statusChamado: [
        {
          text: 'Aberto',
          value: 0
        },
        {
          text: 'Em andamento',
          value: 1
        },
        {
          text: 'Finalizado',
          value: 2
        }
      ],
      loadingEstados: false,
      loadingCidades: false,
      comentario: {
        cco_comentario: ''
      },
      status: '',
      busca: '',
      atrasados: false,
      meus_chamados: false,
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'cha_id'
        },
        { text: 'Cliente', value: 'cliente', align: 'center', width: 300 },
        { text: 'Aberto por', value: 'usuario.usu_nome', align: 'center', width: 300 },
        { text: 'Abertura', value: 'cha_criado_em', align: 'center' },
        { text: 'Atualização', value: 'cha_atualizado_em', align: 'center' },
        { text: 'Finalização', value: 'cha_finalizado_em', align: 'center' },
        { text: 'Prazo', value: 'prazo', align: 'center' },
        {
          text: 'Status',
          align: 'center',
          value: 'cha_status'
        },
        { text: 'Descrição', value: 'cha_descricao', width: '40%' },
        // {
        //   text: 'Comentários',
        //   value: 'comentario',
        //   align: 'center',
        //   sortable: false,
        //   width: 55
        // },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      copiaDados: [],
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['clean']
      ],
      rules: {
        min6: value => !!value[5] || 'minimo 6 caracteres.',
        min: v => !!(v.split(' ').length > 1 & v.split(' ')[1] !== '') || 'Obrigatório nome e sobrenome',
        required: value => !!value || 'Obrigatório.'
      },
      confirmPasswordRules: [
        (value) => !!value || 'Confirme a senha',
        (value) =>
          value === this.cliente.senha || 'A confirmação da senha não corresponde.'
      ],
      chamado: {
        cha_status: 0,
        cha_descricao: '',
        cha_solucao: ''
      },
      dialogExcluir: false,
      cliente: {
        cli_nome: '',
        cli_cep: '',
        cli_uf: '',
        cli_cidade: '',
        cli_bairro: '',
        cli_rua: '',
        cli_numero: '',
        cli_complemento: '',
        cli_telefone: '',
        cli_celular: '',
        cli_email: '',
        cli_usuario: '',
        cli_senha: ''
      },
      comentarios: [],
      loadingComentarios: false,
      headersComentarios: [
        {
          text: 'ID',
          align: 'start',
          value: 'cco_id',
          width: 80
        },
        { text: 'Data', value: 'cco_criado_em', width: 210 },
        { text: 'Usuário', value: 'usuario.usu_nome', width: 150 },
        { text: 'Comentário', value: 'cco_comentario' }
        // {
        //   text: 'Ações',
        //   value: 'actions',
        //   align: 'center',
        //   sortable: false,
        //   width: 110
        // }
      ],
      dadosComentarios: []
    }
  },
  watch: {
    options: {
      handler () {
        this.getChamados(this.de, this.ate, this.meus_chamados, this.busca, this.status, this.atrasados)
      },
      deep: true
    }
  },
  methods: {
    filtraAtrasados () {
      if (this.atrasados) {
        let dados = []
        this.copiaDados.filter(chamado => {
          if (chamado.atrasado && !chamado.cha_finalizado_em) {
            dados.push(chamado)
          }
        })

        this.dados = dados
      } else {
        this.dados = this.copiaDados
      }
    },
    loadContent () {
      this.user = JSON.parse(localStorage.getItem('userData')).usuario
      let filters = this.$route.query
      if (filters.de) this.de = filters.de
      if (filters.ate) this.ate = filters.ate
      if (filters.meus_chamados) this.meus_chamados = true
      if (filters.atrasados) this.atrasados = true
      if (filters.busca) this.busca = filters.busca
      if (filters.status) this.status = Number(filters.status)
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.integrador) this.integrador = filters.integrador
      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }
      this.loadFunctions(this.de, this.ate, this.meus_chamados, this.busca, this.status, this.atrasados)
    },
    loadFunctions (inicio, fim, meusChamados, busca, status, atrasados) {
      this.loading = true
      this.getChamados(inicio, fim, meusChamados, busca, status, atrasados)
      this.getClientes()
      this.getCidade()
      this.getEstados()
      this.getDistribuidores()
      this.getIntegradores()
      this.loadingSearch = false
    },
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    retornoData () {
      if (this.data_entrada.start !== this.de || this.data_entrada.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          this.applyFilter()
        }
      }
    },
    applyFilter () {
      if (this.distribuidorAnterior && this.distribuidor !== this.distribuidorAnterior) {
        this.integrador = ''
      }
      this.loadingSearch = true
      let query = Object.assign({},
        this.de ? { de: this.de } : '',
        this.ate ? { ate: this.ate } : '',
        this.meus_chamados ? { meus_chamados: this.meus_chamados } : '',
        this.atrasados ? { atrasados: this.atrasados } : '',
        this.status ? { status: this.status } : '',
        this.busca ? { busca: this.busca } : '',
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.integrador ? { integrador: this.integrador } : ''
      )
      this.$router.replace({name: 'Chamados', query: query}).catch(() => {})
      if (this.de) {
        this.data_entrada.start = this.de
        if (this.ate) {
          this.data_entrada.end = this.ate
        }
      }
      this.dados = []
      this.distribuidorAnterior = this.distribuidor
      this.getIntegradores(this.distribuidor)
      this.getChamados(this.de, this.ate, this.meus_chamados, this.busca, this.status, this.atrasados)
    },
    limparBusca () {
      this.loading = true
      this.busca = ''
      this.de = ''
      this.ate = ''
      // this.data_entrada.start = moment().startOf('month').format('YYYY-MM-DD')
      this.data_entrada.start = moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD')
      this.data_entrada.end = moment(new Date()).format('YYYY-MM-DD')
      this.meus_chamados = false
      this.atrasados = false
      this.status = ''
      this.$router.replace({name: 'Chamados', query: null}).catch(() => {})
      this.loadFunctions()
    },
    async getChamados (inicio, fim, meusChamados, busca, status, atrasados) {
      let endpoint = inicio ? '&de=' + inicio : '&de='
      endpoint += fim ? '&ate=' + fim : '&ate='
      let usuarioID = this.user.uuid_usu_id ? this.user.uuid_usu_id : this.user.uuid_int_id ? this.user.uuid_int_id : this.user.uuid_dis_id ? this.user.uuid_dis_id : ''
      endpoint += meusChamados ? '&usuario=' + usuarioID : '&usuario='
      endpoint += status ? '&status=' + status : status === 0 ? '&status=0' : '&status='
      endpoint += busca ? '&busca=' + busca : '&busca='
      endpoint += atrasados ? '&atrasados=' + atrasados : '&atrasados='
      if (this.distribuidor) {
        endpoint += '&distribuidor=' + this.distribuidor
      }
      if (this.integrador) {
        endpoint += '&integrador=' + this.integrador
      }
      this.carregando = true
      this.dados = []
      this.total = 0
      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 10
      if (page) {
        pagina = page
      }
      if (itemsPerPage) {
        itensPagina = itemsPerPage
      }
      await Api.get(`chamados?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          let cha = []
          if (res.data.data.length) {
            res.data.data.map(item => {
              if (this.sla) {
                let prazo = moment(item.cha_criado_em).add(this.sla, 'hours').format('YYYY-MM-DD HH:mm:ss')
                let limite = moment(prazo).format('YYYY-MM-DD HH:mm:ss')
                let agora = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')

                item.prazo = moment(prazo).format('DD/MM/YYYY HH:mm')
                item.atrasado = agora > limite
              }
              // let teste = prazo.diff(item.cha_criado_em, 'minutes')
              item.cha_criado_em = item.cha_criado_em ? moment(item.cha_criado_em).format('DD/MM/YYYY HH:mm') : ''
              item.cha_atualizado_em = item.cha_atualizado_em ? moment(item.cha_atualizado_em).format('DD/MM/YYYY HH:mm') : ''
              item.cha_finalizado_em = item.cha_finalizado_em ? moment(item.cha_finalizado_em).format('DD/MM/YYYY HH:mm') : ''
            })
            this.total = res.data.total
            cha = res.data.data
          }
          cha.sort(chamado => {
            if (chamado.atrasado) {
              return 1
            }
          })
          this.dados = cha
          this.copiaDados = JSON.parse(JSON.stringify(this.dados))
          this.loading = false
          this.loadingSearch = false
          this.carregando = false
        })
        .catch(err => {
          this.loading = false
          this.carregando = false
          this.loadingSearch = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os chamados!',
            color: 'error'
          })
          console.log(err)
        })
    },
    saveEditChamado () {
      if (!this.$refs.formChamado.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      if (this.chamado.cha_descricao.length < 17) {
        this.$root.SnackControl.open(this, {
          text: 'Comentário deve conter no mínimo 10 dígitos',
          color: 'error'
        })
        return false
      }
      this.salvando = true
      let endpoint = 'chamados/novo'
      if (this.chamado.uuid_cha_id) {
        endpoint = 'chamados/edita'
      }
      Api.post(endpoint, this.chamado)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.closeDialog()
          this.goToChamado(response.data.data)
          // this.getChamados()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    async getClientes () {
      this.loadingClientes = true
      await Api.get('clientes')
        .then(res => {
          var arrayCli = []
          res.data.map(cli => {
            arrayCli.push({
              'text': cli.cli_nome,
              'value': cli.uuid_cli_id
            })
          })
          this.clientes = arrayCli
          this.loadingClientes = false
        })
        .catch(err => {
          this.loadingClientes = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os clientes!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDistribuidores () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores')
        .then(res => {
          var arrayDists = []
          res.data.map(dist => {
            arrayDists.push({
              'text': dist.dis_nome,
              'value': dist.uuid_dis_id
            })
          })
          this.distribuidores = arrayDists
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegradores (distribuidor = null, cadastro = false) {
      this.loadingIntegradores = true
      let url = 'integradores'

      if (distribuidor) {
        url = `integradores/distribuidor/${distribuidor}`
      }
      await Api.get(url)
        .then(res => {
          var arrayInt = []
          res.data.map(int => {
            arrayInt.push({
              'text': int.int_nome,
              'value': int.uuid_int_id
            })
          })
          if (cadastro || (!cadastro && !distribuidor)) {
            this.integradoresCadastro = arrayInt
          }

          if (!cadastro) {
            this.integradores = arrayInt
          }
          this.loadingIntegradores = false
        })
        .catch(err => {
          this.loadingIntegradores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    goToChamado (item) {
      this.$router.push({ name: 'Chamado', params: { uuid: item.uuid_cha_id } }).catch(() => {})
    },
    openNovo (item) {
      this.salvando = true
      this.dialogNovo = true
      Api.get('chamados/' + item.uuid_cha_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.chamado = JSON.parse(JSON.stringify(response.data))
          this.chamado.uuid_cli_id = response.data.cliente.uuid_cli_id
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados do chamado!',
            color: 'error'
          })
        })
    },
    closeDialog () {
      this.chamado = {
        cha_status: 0,
        cha_descricao: '',
        cha_solucao: ''
      }
      if (this.$refs.formChamado) {
        this.$refs.formChamado.resetValidation()
      }
      this.dialogNovo = false
    },
    saveCliente () {
      if (!this.$refs.formCliente.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      Api.post('clientes/novo', this.cliente)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Cliente cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialogCliente()
          this.getClientes()
          this.chamado.uuid_cli_id = response.data.uuid_cli_id
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    closeDialogCliente () {
      this.cliente = {
        cli_nome: '',
        cli_cep: '',
        cli_uf: '',
        cli_cidade: '',
        cli_bairro: '',
        cli_rua: '',
        cli_numero: '',
        cli_complemento: '',
        cli_telefone: '',
        cli_celular: '',
        cli_email: '',
        cli_usuario: '',
        cli_senha: ''
      }
      if (this.$refs.formCliente) {
        this.$refs.formCliente.resetValidation()
      }
      this.dialogCliente = false
    },
    opendialogDelete (item) {
      this.chamado = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelDialogDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    removeChamado () {
      this.salvando = true
      Api.delete(`chamados/remove/${this.chamado.uuid_cha_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getChamados()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover chamado!',
            color: 'error'
          })
        })
    },
    closeDialogComentarios () {
      if (this.$refs.formComentarios) {
        this.$refs.formComentarios.resetValidation()
      }
      this.closeDialog()
      this.dialogComentarios = false
      this.comentario = {
        cco_comentario: ''
      }
    },
    getComentarios (item) {
      this.salvando = true
      this.dialogComentarios = true
      this.loadingComentarios = true
      this.chamado = item
      Api.get('chamados/' + item.uuid_cha_id + '/comentarios')
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.dadosComentarios = response.data
          let cha = []
          if (response.data.length) {
            response.data.map(item => {
              item.cco_criado_em = item.cco_criado_em ? moment(item.cco_criado_em).format('DD/MM/YYYY HH:mm') : ''
            })
            cha = response.data
          }
          this.dadosComentarios = cha
          this.loadingComentarios = false
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar os comentários!',
            color: 'error'
          })
        })
    },
    salvaComentario () {
      if (!this.$refs.formComentarios.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      Api.post('chamados/' + this.chamado.uuid_cha_id + '/comentarios/novo', this.comentario)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: 'Comentário cadastrado com sucesso!',
            color: 'success'
          })
          this.comentario = {
            cco_comentario: ''
          }
          this.getComentarios(this.chamado)
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    searchCep (cep = '') {
      if (cep.length === 8) {
        this.loadingCep = true
        axios.get('https://viacep.com.br/ws/' + cep + '/json/')
          .then((response) => {
            if (!response.data.erro) {
              this.cliente.cli_rua = response.data.logradouro
              this.cliente.cli_bairro = response.data.bairro
              this.cliente.cli_complemento = response.data.complemento
              if (response.data.uf) {
                this.cliente.cli_uf = response.data.uf
                this.cliente.cli_cidade = response.data.localidade
                this.filterCidade(response.data.uf)
              }
            }
          })
          .catch(err => {
            console.log(err)
            this.$root.SnackControl.open(this, {
              text: 'Erro ao buscar por CEP!',
              color: 'error'
            })
          }).finally(() => {
            this.loadingCep = false
          })
      }
    },
    getEstados () {
      this.loadingEstados = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then((response) => {
          for (let estado = 0; estado < response.data.length; estado++) {
            this.estados.push({
              text: response.data[estado].nome,
              value: response.data[estado].sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os estados!',
            color: 'error'
          })
        })
      this.loadingEstados = false
    },
    getCidade () {
      this.loadingCidades = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios')
        .then((response) => {
          for (let cidade = 0; cidade < response.data.length; cidade++) {
            this.cidades.push({
              text: response.data[cidade].nome,
              value: response.data[cidade].nome,
              uf: response.data[cidade].microrregiao.mesorregiao.UF.sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar as cidades!',
            color: 'error'
          })
        })
      this.loadingCidades = false
    },
    filterCidade (estado) {
      this.cidadesFiltradas = this.cidades.filter(city => city.uf === estado)
    },
    async getSlaDistribuidor () {
      await Api.get(`usuarios/tempo-sla/distribuidor`)
        .then(res => {
          this.sla = res.data
        })
        .catch(() => {
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar SLA!',
            color: 'error'
          })
        })
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        this.user = JSON.parse(localStorage.getItem('user'))
        if (this.user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (this.user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (this.user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  async created () {
    await this.getSlaDistribuidor()
    this.updateData()
    this.loadContent()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.mw_status {
  height: 25px!important;
  min-width: 95px;
  justify-content: center;
  padding: 0 5px!important;
}
.dark_theme {
  >>> .ql-snow .ql-stroke {
    stroke: white!important;
  }
  >>> .ql-active {
    stroke: $primary!important
  }
}
.search_data {
  padding-bottom: 10px!important;
  padding-top: 11px!important;
}
>>> .text {
  p {
    margin-bottom: 0px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/chamados/Chamados.vue